import React from 'react';
import "../../component/styles/styles.scss";
import Container from "react-bootstrap/Container";
import { gradientColors } from "../../component/data/data";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Usegradientcolorcontext } from '../../utils/Hooks/Gradient/Gradientcolor';

export default function Gradientcolorwrapper() {
    const {  copy, handleGradientColors } = Usegradientcolorcontext();

    return (
        <Container fluid>
            <div
                className="red-color-pallete-wrapper"
            >
                <h1>Gradients</h1>
                <p>Dive into a stunning array of gradient colors for your next project.</p>
                <p>Click to copy!</p>
                <h2>Gradient Shades</h2>

                <Row>
                    {gradientColors.map((getBgColor, i) => {
                        return (
                            <Col md="3" key={i}>
                                <div
                                    className="gradient-wrapper"
                                    onClick={() =>
                                        handleGradientColors(getBgColor.gradientColorCodes)
                                    }
                                >
                                    <div
                                        className="color-wrapper"
                                        style={{
                                            backgroundImage: `linear-gradient(${getBgColor.gradientColorCodes})`,
                                        }}
                                    ></div>
                                    {copy === getBgColor.gradientColorCodes ? (
                                        <h5>Copied!</h5>
                                    ) : (
                                        ""
                                    )}
                                    <p>
                                        HEX: <span>{getBgColor.gradientColorCodes.toUpperCase()}</span>
                                    </p>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </Container>
    )
}
